import styled from "styled-components";
import { Navbar } from "react-bootstrap";

export const TopMenuContainer = styled(Navbar)`
  padding: 0;
  background: white;
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.1);

  /* topmenu link items */
  .navbar-nav a.nav-link {
    display: inline-block;
    color: var(--heeros-blue);
    text-align: center;
    font-size: 85%;
    margin-right: 1em;
  }

  svg {
    margin: 0 !important;
    width: 24px;
    height: 24px;
    fill: var(--heeros-blue);
  }

  span {
    display: block;
  }

  /* fix out of bounds topmenu dropdown */
  .dropdown-menu {
    min-width: initial;
  }

  @media only screen and (max-width: 767px) {
    background: var(--heeros-blue);

    .navbar-collapse {
      padding: 0 0.5em;
      position: fixed;
      right: 0;
      top: 0;
      background: var(--bs-light);
      z-index: 1;
      border: 1px solid rgba(51, 51, 51, 0.19);
      text-align: center;
    }

    .wrap {
      height: calc(100vh - 9px - 2rem);
    }

    .dashboard-cards .card {
      width: calc(100% - 2rem) !important;
    }
  }
`;
